import { cn } from "@/lib/utils";

interface PhoneMockupProps {
  image?: string;
  alt?: string;
  className?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

export function PhoneMockup({
  image,
  alt = "App screenshot",
  className,
  gradientFrom = "#DAD7CD",
  gradientTo = "#8B9A7D",
}: PhoneMockupProps) {
  return (
    <div
      className={cn(
        "relative mx-auto w-[240px] sm:w-[280px] aspect-[9/19.5]",
        className
      )}
    >
      {/* Phone frame */}
      <div className="absolute inset-0 bg-foreground rounded-[2.5rem] p-[3px] shadow-xl">
        {/* Inner bezel */}
        <div className="w-full h-full bg-black rounded-[2.3rem] p-[2px]">
          {/* Screen */}
          <div className="w-full h-full rounded-[2.2rem] overflow-hidden bg-white">
            {image ? (
              <img
                src={image}
                alt={alt}
                className="w-full h-full object-cover"
              />
            ) : (
              /* Placeholder gradient */
              <div
                className="w-full h-full"
                style={{
                  background: `linear-gradient(135deg, ${gradientFrom} 0%, ${gradientTo} 100%)`,
                }}
              />
            )}
          </div>
        </div>
      </div>

      {/* Notch / Dynamic Island */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2 w-[80px] h-[25px] bg-black rounded-full z-10" />
    </div>
  );
}
